import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  Link,
  Box,
  CircularProgress,
} from '@mui/material';

import { useEffect, useState } from 'react';

import { createJiraTicket } from '../../services/activeRunsService';

export default function JiraTicketModal({
  open,
  onClose,
  analysisData,
  isCreatingTicket,
  setIsCreatingTicket,
}) {
  const [ticketResponse, setTicketResponse] = useState(null);

  const [ticketError, setTicketError] = useState('');

  useEffect(() => {
    if (open && analysisData) {
      createTicket();
    }
  }, [open]);

  const createTicket = async () => {
    try {
      setIsCreatingTicket(true);

      setTicketError('');

      setTicketResponse(null);

      const response = await createJiraTicket(analysisData);

      setTicketResponse(response);
    } catch (error) {
      setTicketError(error?.response?.data?.message || 'Failed to create Jira ticket.');
    } finally {
      setIsCreatingTicket(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Jira Ticket Details</DialogTitle>

      <DialogContent dividers>
        {isCreatingTicket && (
          <Box display="flex" justifyContent="center" alignItems="center" py={3}>
            <CircularProgress />
          </Box>
        )}

        {!isCreatingTicket && ticketError && <Alert severity="error">{ticketError}</Alert>}

        {!isCreatingTicket && !ticketError && ticketResponse && (
          <Box display="flex" flexDirection="column" gap={2}>
            <Typography>
              <strong>Ticket ID:</strong> {ticketResponse.ticket_id}
            </Typography>

            <Typography>
              <strong>Message:</strong> {ticketResponse.message}
            </Typography>

            {ticketResponse.ticket_url && (
              <Link
                href={ticketResponse.ticket_url}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                Open Jira Ticket
              </Link>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
